var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _c("label", { attrs: { for: _vm.name } }, [_vm._v(_vm._s(_vm.label))]),
    _vm._v(" "),
    _vm.required
      ? _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }